module.exports = __webpack_public_path__ + "assets/media_black.160517d1.svg";